<template>
  <div class="teachers">
    <siteHeader />
    
    <!-- 轮播图区域 -->
    <div class="slider-container">
      <div class="slider">
        <div class="slide">
          <el-carousel
            height="400px"
            :interval="3000"
            trigger="hover"
            :autoplay="true"
            indicator-position="outside"
            v-if="bannerList.length">
            <el-carousel-item v-for="item in bannerList" :key="item.id">
              <div class="slide-content" :style="{ backgroundImage: `url(${item.url})` }"></div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    
    <div class="content">
      <div class="container">
        <page-breadcrumb :paths="['办学特色', currentTab]" />
        
        <div class="page-content">
          <div class="left-nav">
            <h3>办学特色</h3>
            <ul>
              <li 
                v-for="tab in tabs" 
                :key="tab.name"
                :class="{ active: currentTab === tab.name }"
                @click="switchTab(tab.name)"
              >
                {{ tab.name }}
              </li>
            </ul>
          </div>

          <div class="right-content">
            <div v-if="currentTab === '教材研发'" class="feature-section">
              <img :src="tabs[0].bgImage" alt="教材研发" class="feature-image">
            </div>
            <div v-else-if="currentTab === '沉浸教学'" class="feature-section">
              <img :src="tabs[1].bgImage" alt="沉浸教学" class="feature-image">
            </div>
          </div>
        </div>
      </div>
    </div>
    <siteFooter />
  </div>
</template>

<script>
import PageBreadcrumb from '@/components/Breadcrumb.vue'
import siteHeader from '../components/SiteHeader.vue'
import siteFooter from '../components/SiteFooter.vue'
import { websiteApi } from '@/api'
import jiaocaiImg from '@/assets/jiaocai.jpg'
import chenjingImg from '@/assets/chenjing.jpg'

export default {
  name: 'TeachersPage',
  components: {
    'page-breadcrumb': PageBreadcrumb,
    siteHeader,
    siteFooter
  },
  data() {
    return {
      currentTab: '教材研发',
      tabs: [
        { name: '教材研发', categoryId: 23, bgImage: jiaocaiImg },
        { name: '沉浸教学', categoryId: 24, bgImage: chenjingImg }
      ],
      teachers: [],
      bannerList: []
    }
  },
  async created() {
    const tab = this.$route.query.tab
    if (tab && this.tabs.some(t => t.name === tab)) {
      this.currentTab = tab
    }
    
    await Promise.all([
      this.loadTeacherData(),
      this.getBanners()
    ])
  },
  methods: {
    async switchTab(tabName) {
      this.currentTab = tabName
      this.$router.push({
        query: { ...this.$route.query, tab: tabName }
      })
      
      await this.loadTeacherData()
    },
    async loadTeacherData() {
      try {
        const currentTabData = this.tabs.find(tab => tab.name === this.currentTab)
        const response = await websiteApi.getTcTrainArticle({ 
          categoryId: currentTabData.categoryId 
        })
        
        if (response && response.code === 200) {
          this.teachers = response.rows || []
        } else {
          console.error('API返回数据异常:', response)
          this.teachers = []
        }
      } catch (error) {
        console.error('加载教师数据失败:', error)
        this.teachers = []
      }
    },
    async getBanners() {
      try {
        const response = await websiteApi.getPictureList()
        if (response && response.code === 200) {
          // 筛选出 location 为特定值的轮播图数据 (使用与首页不同的location值)
          this.bannerList = response.rows
            .filter(item => item.location === 2) // 假设Teachers页面使用location为2的轮播图
            .map(item => ({
              id: item.id,
              url: item.carouselUrl,
              description: item.remark || ""
            }))
        } else {
          console.error('获取轮播图数据异常:', response)
          this.bannerList = []
        }
      } catch (error) {
        console.error('获取轮播图失败:', error)
        this.bannerList = []
      }
    }
  }
}
</script>

<style scoped>
.content {
  padding: 20px 0 40px 0;
  min-height: calc(100vh - 60px);
  background: transparent;
}

/* 轮播图样式 */
.slider-container {
  width: 100%;
  overflow: hidden;
}

.slider {
  width: 100%;
}

.slide {
  width: 100%;
}

.slide-content {
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

.full-width {
  max-width: 100%;
  padding: 0;
}

.page-content {
  display: flex;
  gap: 30px;
  margin-top: 20px;
}

.left-nav {
  width: 200px;
  background: transparent;
  padding: 20px;
  border-radius: 4px;
  /* box-shadow: 0 2px 4px rgba(0,0,0,0.05); */
  position: sticky;
  top: 80px;
  align-self: flex-start;
  max-height: calc(100vh - 160px);
  overflow-y: auto;
  color: #dddddd;
}

.left-nav h3 {
  margin: 0 0 15px 0;
  padding-bottom: 10px;
  /* border-bottom: 2px solid #1e88e5; */
  color: #333;
}

.left-nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.left-nav li {
  padding: 12px 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 4px;
}

.left-nav li:hover {
  background: #e3f2fd;
  /* color: #1e88e5; */
}

.left-nav li.active {
  /* background: #1e88e5; */
  color: #0b0b0b;
}

.right-content {
  flex: 1;
  background: transparent;
  padding: 30px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.full-width-content {
  padding: 30px 0;
  box-shadow: none;
}

.right-content h2 {
  display: none;
}

.teachers-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

.teacher-card {
  padding: 20px;
  border: 1px solid #eee;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.teacher-card:hover {
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  transform: translateY(-2px);
}

.teacher-info h3 {
  margin: 0 0 10px 0;
  color: #333;
}

.teacher-info .title {
  color: #1e88e5;
  margin: 0 0 10px 0;
}

.teacher-info .description {
  color: #666;
  line-height: 1.6;
  margin: 0;
}

.teacher-avatar {
  width: 200px;
  height: 200px;
  object-fit: cover;
  border-radius: 4px;
  margin-bottom: 15px;
}

.gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

.gallery-item {
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 15px;
  transition: all 0.3s ease;
}

.gallery-item:hover {
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  transform: translateY(-2px);
}

.gallery-item img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 4px;
  margin-bottom: 10px;
}

.gallery-item h3 {
  margin: 10px 0;
  color: #333;
}

.gallery-content {
  color: #666;
  line-height: 1.6;
}

/* 处理富文本内容样式 */
:deep(.description p), 
:deep(.gallery-content p) {
  margin: 0;
  line-height: 1.6;
}

.feature-section {
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
}

.feature-image {
  width: 100%;
  height: auto;
  display: block;
}

.overlay {
  display: none;
}
</style> 